import { render, staticRenderFns } from "./JoinRecipients.vue?vue&type=template&id=7fabd9c0&scoped=true&"
import script from "./JoinRecipients.vue?vue&type=script&lang=js&"
export * from "./JoinRecipients.vue?vue&type=script&lang=js&"
import style0 from "./JoinRecipients.vue?vue&type=style&index=0&id=7fabd9c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fabd9c0",
  null
  
)

export default component.exports